import styled from 'styled-components';
import { Header as HeaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: 100%;
  padding: 20px 200px 100px 250px;
`;

export const Header = styled(HeaderLayoutComponent)`
  text-align: justify;
  margin-bottom: 0px;
  font-size: 24px;
`;
